module.exports = __webpack_public_path__ + "static/media/food.71e020fb.png";